import React, {useEffect, useState} from 'react';
import Button from 'react-bootstrap/Button';
import {useTranslation} from "react-i18next";
import {Accordion, Alert, Card} from "react-bootstrap";
import Quiz from "./Quiz";
import {InputTags} from 'react-bootstrap-tagsinput'
import 'react-bootstrap-tagsinput/dist/index.css'
import {useParams} from "react-router-dom";
import Loading from "./Loading";
import {questionsApi} from '../api/_360_questions'

function _360AnonymousResponse(props: any) {
    const {i18n} = useTranslation();
    let {signature} = useParams();
    const [linkValid, setLinkValid] = useState(false)
    const [requestedBy, setRequestedBy] = useState("...")
    const [loading,setLoading] = useState(true)

    useEffect(() => {
        //check if this link is still valid :
        fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/360-feedback-ok', {
            method: 'POST',
            body: JSON.stringify({
                signature: signature
            })
        }).then(response => {
            if (response.status === 200) {
                response.json().then(res => {
                    setLinkValid(true);
                    setRequestedBy(res.requested_by);
                    console.log(res);
                })
            } else {
                setLinkValid(false);
            }
            setLoading(false);
        });
    },[])


    const questions = questionsApi[i18n.language]
    const [currentAnswer, setCurrentAnswer] = useState("0")
    const [currentQuestion, setCurrentQuestion] = useState(questions[0].respondentQuestion)
    const [currentQuestionId, setCurrentQuestionId] = useState(questions[0].id)
    const [counter, setCounter] = useState(0)
    const [reportLink, setReportLink] = useState("")
    const [answerState, setAnswerState] = useState(new Map<String, String>())
    const [quizCompleted, setQuizCompleted] = useState(false);

    const answerOptions = ["0","1", "2", "3", "4", "5","6","7"]
    const [emails, setEmails] = useState<string[]>([])

    const setUserAnswer = answer => {
        let newAnswerState = answerState
        newAnswerState.set(questions[counter].id, answer)
        setCurrentAnswer(answer)
        setAnswerState(newAnswerState)
    }
    const setNextQuestion = () => {
        if (counter < questions.length - 1) {
            setCounter(counter + 1)
            setCurrentAnswer('0')
        }
    }
    const getResults = () => {
        setQuizCompleted(true);
    }
    const handleAnswerSelected = event => {
        console.log("answer selected " + event.currentTarget.value)
        setUserAnswer(event.currentTarget.value);
        if (counter < questions.length - 1) {
            setTimeout(() => setNextQuestion(), 500);
        } else {
            setTimeout(() => getResults(), 300);
        }
    }

    const handleBackSelected = () => {
        if (counter > 0) {
            setCounter(counter - 1)
        }
    }

    const sendFeedback = () => {
        setLoading(true)
        const convMap: any = {};
        answerState.forEach((val, key) => {
            convMap[key as string] = val;
        });
        fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/360-feedback-response', {
            method: 'POST',
            body: JSON.stringify({
                signature: signature,
                feedback:convMap
            })
        }).then(response => {
            if (response.status === 200) {
                response.json().then(res => {
                    setLinkValid(false);
                    console.log(res);
                })
            }
            setLoading(false);
        });
    }

    const meaningMap = (i18n) => new Map(Object.entries({
        "0": {label:i18n.t('0 - I dont know'),hotkey:"0"},
        "1": {label:i18n.t('1 - I strongly disagree'),hotkey:"1"},
        "2": {label:i18n.t('2 - I disagree'),hotkey:"2"},
        "3": {label:i18n.t('3 - I somewhat disagree'),hotkey:"3"},
        "4": {label:i18n.t('4 - I neither agree nor disagree'),hotkey:"4"},
        "5": {label:i18n.t('5 - I somewhat agree'),hotkey:"5"},
        "6": {label:i18n.t('6 - I agree'),hotkey:"6"},
        "7": {label:i18n.t('7 - I strongly agree'),hotkey:"7"}
    }))


    const content = ()=> {
        return (<div>
            {linkValid ? <div>
                <br/><br/>
                <h1>Welcome to MyOceanity, </h1>
                <h2>You are providing anonymous 360 feedback to {requestedBy}</h2>
                <h3> {requestedBy} will see an aggregated report of all responses, they cannot access individual
                    responses </h3>
                <h3> You will only be able to provide your responses once </h3>
                <Quiz
                    answer={answerState.get(questions[counter].id) as string}
                    answerOptions={answerOptions}
                    questionId={questions[counter].id}
                    question={questions[counter].respondentQuestion.replaceAll("{USER}",requestedBy)}
                    questionTotal={questions.length}
                    onAnswerSelected={handleAnswerSelected}
                    onBack={handleBackSelected}
                    counter={counter}
                    reportLink={reportLink}
                    meaningMap={meaningMap}
                />
                <Button disabled={!quizCompleted} onClick={()=>sendFeedback()}>Submit your responses</Button>
            </div> : <div>Thank you ! You have already provided feedback or this link has expired</div>}</div>)

    }
    return !loading?content():<Loading />;
}

export default _360AnonymousResponse;
